module.exports = __webpack_public_path__ + "static/erp-3fbbd57b561adad59a4fdb4c84273d01.jpg";